const siteMetadata = {
  appName: "ON Plus",
  title: "ON Plus - Xem trực tiếp bóng đá, thể thao, tin tức số 1 Việt Nam",
  author: "Mise.ai",
  headerTitle: "DeFi for home",
  description:
    "ON Plus tin tức thể thao mới nhất - Thông tin nhanh & chính xác được cập nhật hàng giờ. Đọc báo thể thao online Việt Nam & Thế giới nóng nhất trong ngày về thể thao,...",
  siteLogo: "/siteLogo.png",
  siteUrl: "https://mise.ai",
  theme: "light", // system, dark or light
  thumb: "https://stvinaprod.vtvcab.vn/6ba1de50-b726-4675-a372-3df496440086.png"
}

export default siteMetadata
